/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ComponentType } from 'react';
import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import {
	composeLayouts,
	withProjectContext,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import IntentTemplatesSidebar from './ui/right-sidebars/index.tsx';

// TODO Remove this whenever all service project route paths are no longer ambiguous
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const withServiceProjectContext = (Component: ComponentType<Record<any, any>>) =>
	withProjectContext(Component, {
		project: {
			style: 'any',
			type: SERVICE_DESK_PROJECT,
		},
	});

export const browseIntentsLayout: Layout = composeLayouts(serviceProjectLayout, {
	rightSidebars: [withServiceProjectContext(IntentTemplatesSidebar)],
});
